<template>
  <el-row class="box">
    <!-- <el-row type="flex" class="row-bg-top header" justify="center">
            <el-col :span="12" class='content'>
                <el-row class=" head_top" > 
                    <el-col :span="10" class='head_top_left'>  
                         <a href="#" class="head-title">江苏省音乐家协会欢迎您</a>         
                    </el-col>    
                    <el-col :span="9" class='search'>  
                       <div class="flex_cc search_info">
                            <input type="text" class='input'><input type="submit" value='搜索' class='searchBtn'>
                       </div>
                    </el-col>
                    <el-col :span="5" class='top_login'>  
                        <a href="#" class='cor' @click='()=>{this.$router.push({name:"Register"})}'>注册</a> 
                        | <a href="#" class='cor' @click='()=>{this.$router.push({name:"Login"})}'>登录</a>     
                    </el-col>
                </el-row>    
            </el-col>
    </el-row>-->
    <div>
      <!-- <personaldata-vue></personaldata-vue> -->

      <el-row>
        <!-- <el-tabs :tab-position="tabPosition" @tab-click="handleTypeChange">
                <el-tab-pane label="报名记录">
                  <enter-vue></enter-vue>
                </el-tab-pane>
                <el-tab-pane label="辅导课记录">
                  <tutorial-vue></tutorial-vue>
                </el-tab-pane>
                <el-tab-pane label="账单明细">
                  <billdetail-vue></billdetail-vue>
                </el-tab-pane>
                <el-tab-pane label="网上报名">
                  <div class="post_content" v-show="signShow">
                    <onlineregisl-vue></onlineregisl-vue>
                    <div class="button_btn">
                      <button class="btn" @click="signChange">我已阅读，立即报名</button>
                    </div>
                  </div>
                  <div v-show="!signShow">
                    <fillfrom-vue></fillfrom-vue>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="个人资料">
                  <datadetail-vue></datadetail-vue>
                </el-tab-pane>
        </el-tabs>-->
        <ul class="tabs-part">
          <router-link to="/indexSign">
            <li class="tab_li">报名记录</li>
          </router-link>
          <router-link to="/indexTutorial">
            <li class="tab_li">辅导课记录</li>
          </router-link>
          <!-- <router-link to="/indexBill">
            <li class="tab_li">账单明细</li>
          </router-link> -->
          <router-link to="/indexOnline">
            <li class="tab_li">网上报名</li>
          </router-link>
          <router-link to="/indexPerson">
            <li class="tab_li">个人资料</li>
          </router-link>
          <router-link to="/indexScore">
            <li class="tab_li">成绩查询</li>
          </router-link>
        </ul>
        <!-- <el-tabs
          v-model="indexId"
          @tab-remove="removeTab"
          :tab-position="tabPosition"
          @tab-click="handleTypeChange"
        >
          <el-tab-pane
            v-for="item in editableTabs2"
            :key="item.name"
            :label="item.title"
            :name="item.name"
          ></el-tab-pane>
        </el-tabs>-->
      </el-row>
      <!-- <p class="box_footer">省音协考级报名咨询电话 025-83572077</p> -->
    </div>
  </el-row>
</template>
<script>
// import onlineVue from '@/views/fillFrom'
export default {
  data() {
    return {
      // tabPosition: "left",
      // activeName1: "second",
      // editableTabsValue2: "2",
      // editableTabs2: [
      //   {
      //     title: "报名记录",
      //     name: "1",
      //     content: "Tab 1 content"
      //   },
      //   {
      //     title: "辅导课记录",
      //     name: "2",
      //     content: "Tab 2 content"
      //   },
      //   {
      //     title: "账单明细",
      //     name: "3",
      //     content: "Tab 2 content"
      //   },
      //   {
      //     title: "网上报名",
      //     name: "4",
      //     content: "Tab 2 content"
      //   },
      //   {
      //     title: "个人资料",
      //     name: "5",
      //     content: "Tab 2 content"
      //   }
      // ],
      // tabIndex: 2
    };
  },
  created() {
    // window.Global.getLocalStorage(token);
    // console.log(window.Global.getLocalStorage(token));
  },
  methods: {
    // fillfrom(data){
    //   this.isSign=true
    //   this.signShow=data
    //   console.log(this.signShow,111222)
    // },
    // handleTypeChange(tab, event) {
    //   let that = this;
    //   console.log("tab.index", tab.index);
    //   if (tab.index == 0) {
    //     that.$router.push({ name: "indexSign" });
    //   } else if (tab.index == 1) {
    //     that.$router.push({ name: "indexTutorial"});
    //   } else if (tab.index == 2) {
    //     that.$router.push({ name: "indexBill" });
    //   } else if (tab.index == 3) {
    //     that.$router.push({ name: "indexOnline" });
    //   } else if (tab.index == 4) {
    //     that.$router.push({ name: "indexPerson" });
    //   }
    // }
    // signChange() {
    //   this.signShow = false;
    //   console.log(111);
    // },
    // handleClick(tab, event) {
    //   console.log(tab, event);
    // },
    // submitForm(formName) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       alert("submit!");
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    // handleAvatarSuccess(res, file) {
    //   this.imageUrl = URL.createObjectURL(file.raw);
    // },
    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === "image/jpeg";
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //   if (!isJPG) {
    //     this.$message.error("上传头像图片只能是 JPG 格式!");
    //   }
    //   if (!isLt2M) {
    //     this.$message.error("上传头像图片大小不能超过 2MB!");
    //   }
    //   return isJPG && isLt2M;
    // }
  }
};
</script>
<style lang="less">
@import "../../static/less/bg.less";
@import "../../static/less/personalData.less";
.tabs-part {
  background: #f9fafc;
  text-align: center;
  .tab_li {
    font-size: 14px;
    // height: 30px;
    // line-height: 30px;
    padding: 6px 0;
    color: #666;
    // word-break: normal ;
    white-space: nowrap;
  }
  a.router-link-exact-active .tab_li {
    background: #e6dfd5;
    border-left: 2px solid #9e7536;
    color: #9e7536;
  }
}
</style>


   


// WEBPACK FOOTER //
// src/components/tabLeft.vue